export default __webpack_public_path__ + "static/eco-product-1-777fbfd9288cc008327b4de6c095bea3.svg";